'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$35() {
  this.bgu = null;
  this.bgs = null;
  this.bgt = false;
  this.bgq = null;
  this.bgr = false;
  this.bgv = false;
  this.bgw = false;
  this.bgu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$35 as $c_Lpresto_PrestoRouter$$anon$35 };
$p = $c_Lpresto_PrestoRouter$$anon$35.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$35;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$35() {
}
export { $h_Lpresto_PrestoRouter$$anon$35 as $h_Lpresto_PrestoRouter$$anon$35 };
$h_Lpresto_PrestoRouter$$anon$35.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bgu;
});
$p.t = (function() {
  if ((!this.bgt)) {
    this.bgs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("token", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bgt = true;
  }
  return this.bgs;
});
$p.ad = (function() {
  if ((!this.bgr)) {
    this.bgq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bgr = true;
  }
  return this.bgq;
});
$p.v = (function() {
  if ((!this.bgw)) {
    this.bgv = false;
    this.bgw = true;
  }
  return this.bgv;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$35 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$35, "presto.PrestoRouter$$anon$35", ({
  Oa: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$35 as $d_Lpresto_PrestoRouter$$anon$35 };
//# sourceMappingURL=presto.-Presto-Router$$anon$35.js.map
